import { Switch } from "@/components/ui/switch";
import { Lock, Unlock } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface LockToggleProps {
  locked: boolean;
  onToggle: (checked: boolean) => void;
  tooltip?: string;
  className?: string;
}

export function LockToggle({ locked, onToggle, tooltip, className = "" }: LockToggleProps) {
  const content = (
    <div className={`flex items-center justify-center gap-2 py-2 ${className}`}>
      <Unlock 
        className={`w-4 h-4 ${!locked ? 'text-muted-foreground' : 'hidden'}`}
      />
      <Lock 
        className={`w-4 h-4 ${locked ? 'text-muted-foreground' : 'hidden'}`}
      />
      <Switch
        checked={locked}
        onCheckedChange={onToggle}
        className="data-[state=checked]:bg-primary"
      />
      <span className="text-sm text-muted-foreground">
        {locked ? "Locked" : "Unlocked"}
      </span>
    </div>
  );

  if (!tooltip) {
    return content;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="cursor-help">
            {content}
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
